import { debounce, throttle } from '@ember/runloop';

import { modifier } from 'ember-modifier';

type CallbackFn = (event: Event, element: HTMLElement) => void;

const onWindowEventsModifier = modifier(
	(
		element,
		[callback, eventNamesString, delayTime = 0]: [CallbackFn, string, number?],
		hashParams: {
			delayFn?: string;
			immediate?: boolean;
		} = {},
	) => {
		let handleEvent: (event: Event) => void;

		if (delayTime) {
			const delayFn = hashParams.delayFn === 'throttle' ? throttle : debounce;
			handleEvent = function (event) {
				delayFn(
					null,
					callback,
					event,
					element as HTMLElement,
					delayTime,
					hashParams.immediate,
				);
			};
		} else {
			handleEvent = function (event) {
				callback(event, element as HTMLElement);
			};
		}

		const eventNames = eventNamesString.split(' ');

		eventNames.forEach((eventName) => {
			window.addEventListener(eventName, handleEvent);
		});

		return () => {
			eventNames.forEach((eventName) => {
				window.removeEventListener(eventName, handleEvent);
			});
		};
	},
);

export default onWindowEventsModifier;
